import Checkbox from "../../../../../components/Checkbox";
import { PimsEvent } from "../types";

interface EventCardProps {
  event: PimsEvent;
  isSelected: boolean;
  onSelectionChange: (eventId: string, checked: boolean) => void;
  selectionMode?: "checkbox" | "radio";
  radioName?: string;
  size?: "small" | "medium";
}

export default function EventCard({
  event,
  isSelected,
  onSelectionChange,
  selectionMode = "checkbox",
  radioName,
  size = "medium",
}: EventCardProps) {
  const handleClick = () => {
    onSelectionChange(event.id, !isSelected);
  };

  const formatDate = (datetime: string) => {
    return new Date(datetime).toLocaleDateString("fr-FR", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const cardClasses =
    size === "small"
      ? "flex items-start gap-2 p-2 border border-border rounded-md bg-input/20 hover:bg-input/40 transition-colors cursor-pointer"
      : "flex items-start gap-3 p-4 border rounded-md transition-colors cursor-pointer";

  const titleClasses =
    size === "small"
      ? "font-medium text-xs mb-1 truncate"
      : "font-medium text-sm mb-2 truncate";

  const venueClasses = "text-accent text-xs mb-2";
  const dateClasses = "text-muted-foreground text-xs mb-2";
  const capacityClasses = "text-muted-foreground text-xs";

  const getBorderClasses = () => {
    if (selectionMode === "radio") {
      return isSelected
        ? "border-primary bg-primary/10"
        : "border-border bg-input/20 hover:bg-input/40";
    }
    return "border-border";
  };

  return (
    <div
      className={`${cardClasses} ${getBorderClasses()}`}
      onClick={handleClick}
    >
      {selectionMode === "radio" ? (
        <input
          type="radio"
          name={radioName}
          checked={isSelected}
          onChange={() => onSelectionChange(event.id, true)}
          className="mt-1"
        />
      ) : (
        <Checkbox
          checked={isSelected}
          onChange={(checked) => onSelectionChange(event.id, checked)}
        />
      )}

      <div className="text-sm min-w-0 flex-1">
        <div
          className={titleClasses}
          title={`${event.label} - ${event.venueLabel} - ${event.venueCity}`}
        >
          {event.label}
        </div>

        {event.venueLabel && event.venueCity && (
          <div className={venueClasses}>
            {event.venueLabel} - {event.venueCity}
          </div>
        )}

        {event.datetime && (
          <div className={dateClasses}>{formatDate(event.datetime)}</div>
        )}

        {event.maxCapacity && (
          <div className={capacityClasses}>Max: {event.maxCapacity}</div>
        )}
      </div>
    </div>
  );
}
